<template>
    <LayoutSoundConsoleGrid
        align-bottom="zend"
        bottom-full-width>
        <template v-slot:elliot>
            <BaseElliotHead />
        </template>
        <template v-slot:text>
            <BaseTextCloud>
                <template v-if="showSkippingMessage">
                    Skipping ahead
                </template>
                <template v-else>
                    {{ activePlaylistItem.text }}
                </template>
            </BaseTextCloud>
        </template>
        <template v-slot:progress>
            <GlobalProgress :progress="playlistProgress" />
        </template>
        <template v-slot:bottom>
            <div class="controls">
                <div class="controls__buttons">
                    <div class="controls__item">
                        <AudioButton
                            color="blue"
                            :src="`${folder}/aux/ButtonGeese.mp3`"
                            title="Play Twitch 1" />
                    </div><!-- __item -->
                    <div class="controls__item">
                        <AudioButton
                            color="red"
                            :src="`${folder}/aux/ButtonBirds.mp3`"
                            title="Play Twitch 1" />
                    </div><!-- __item -->
                    <div class="controls__item  is-primary">
                        <AudioButton
                            @ended="handleEndedEvent"
                            @skipped="handleSkippedEvent"
                            :src="folder + '/' + activePlaylistItem.audio"
                            allowSkip
                            title="Next sound">

                            <template v-slot:default="{data}">
                                <button class="primary-play-button"
                                    @click="handlePrimaryPlayClick(data.handleButtonClick)">
                                    <span v-if="data.isPlaying || showSkippingMessage" class="primary-play-button__playing">Skip</span>
                                    <span v-else class="primary-play-button__idle">Play</span>
                                </button>
                            </template>

                        </AudioButton>
                    </div><!-- __item -->
                    <div class="controls__item">
                        <AudioButton
                            color="yellow"
                            :src="`${folder}/aux/ButtonWind.mp3`"
                            title="Play Twitch 3"/>
                    </div><!-- __item -->
                    <div class="controls__item">
                        <AudioButton
                            color="green"
                            :src="`${folder}/aux/ButtonKids.mp3`"
                            title="Play Twitch 4"/>
                    </div><!-- __item -->
                </div><!-- __buttons -->
                <div class="controls__back">

                    <button class="color-button  pink"
                        @click="back">
                        Back
                    </button>

                </div>
            </div><!-- .controls -->

        </template>
    </LayoutSoundConsoleGrid>
</template>

<style lang="scss" scoped>
    @import '../scss/design.scss';

    .primary-play-button {
        position: relative;
        display: block;
        width: 140px;
        height: 120px;
        border-radius: 100%;
        color: rgba(white, 0);
        font-weight: bold;
        text-align: center;
        @include button-3d(#dc752a);
        &:before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: center / 80px no-repeat url('../assets/icon-sound.png');
            transition: all .25s ease;
        }

        &:hover:before {
            opacity: .75;
        }
    }

    .controls {
        position: relative;
        z-index: 1;
        padding-top: 20px;

        &:after {
            content: '';
            position: absolute;
            z-index: -1;
            top: 0;
            left: 0;
            right: 0;
            margin: 0 auto;
            width: 100%;
            height: 492px;
            background: top center url(/* webpackPrefetch: true */'../assets/controls-branch.png') repeat-x;
        }

        &__buttons {
            display: flex;
            justify-content: center;
            align-items: center;
        }

        &__item {
            flex: 0 0 auto;
            padding: 0 20px;
        }

        &__back {
            text-align: center;
        }
    }
</style>

<script>

import BaseTextCloud from './BaseTextCloud';
import BaseElliotHead from './BaseElliotHead';
import LayoutSoundConsoleGrid from './LayoutSoundConsoleGrid';
import AudioButton from '@/components/AudioButton.vue';
import GlobalProgress from '@/components/GlobalProgress.vue';
import isFunction from 'lodash/isFunction';

// Constants
const SKIP_MESSAGE_DURATION = 2500;

// Actions
const ACTION_FULLSCREEN = 'ACTION_FULLSCREEN';
const ACTION_VIDEO = 'ACTION_VIDEO'

export default {
    name: "home",
    components: {
        AudioButton,
        GlobalProgress,
        BaseTextCloud,
        BaseElliotHead,
        LayoutSoundConsoleGrid
    },
    data() {
        let vm = this;
        // TODO - refactor actions
        let actions = {};
        actions[ACTION_FULLSCREEN] = this.actionFullscreen;
        actions[ACTION_VIDEO] = this.actionVideo;

        return {
            actionLookup: actions,
            showSkippingMessage: false,
            activeIndex: 0,
            folder: '/assets/audio',
            playlist: [
                { text: 'To start things out, press the BIG orange button to go full screen', action: ACTION_FULLSCREEN },
                { audio: 'theme.mp3', text: "When you are ready to start, press the button!" },
                { audio: 'TwitchBurp.mp3', text: 'Press the button when Twitch says “too much soda pop”' },
                { audio: 'CrashLand.mp3', text: 'Press the button when Crash says “tally ho!”' },
                { audio: 'BugleCall.mp3', text: 'Press the button when Ranger Canyon says “roll call!”' },
                { audio: 'OminousCue.mp3', text: 'Press the button when Twitch says “a squirrel!”' },
                { audio: 'Clock.mp3', text: 'Press the button when everyone says “think, think, think”' },
                { audio: 'CrashLaunch.mp3', text: 'Press the button when Crash says “right-o!”' },
                { audio: 'OminousCue.mp3', text: 'Press the button when Scratchy Spurs says “stage a rescue!”' },
                { audio: 'CrashLand.mp3', text: 'Press the button when Elliot says “flying over the party”' },
                { audio: 'OminousCue.mp3', text: 'Press the button when Crash says “one of the gifts is a squirrel”' },
                { audio: 'BirthdayParty.mp3', text: 'Press the button when Elliot says “what the people were saying”' },
                { text: `When you're ready to sing the Elliot's Park song, press the orange button`, action: ACTION_VIDEO }
            ]
        };
    },
    computed: {
        activePlaylistItem() {
            const playlistItem = this.playlist[this.activeIndex];
            return playlistItem;
        },
        isFirstPlaylistItem() {
            return this.activeIndex === 0;
        },
        isLastPlaylistItem() {
            return this.activeIndex === this.playlist.length - 1;
        },
        playlistProgress() {
            if(!this.playlist.length) {
                return 0;
            }
            return this.activeIndex / (this.playlist.length - 1);
        }
    },
    methods: {
        handleInstructionsStart() {
            this.activeView = VIEW_AUDIO;
        },
        handleNoAudioClick() {
            this.progressPlaylist();
        },
        handleSkippedEvent() {
            this.progressPlaylist();
            this.showSkippingMessage = true;
            setTimeout(() => {
                this.showSkippingMessage = false;
            }, SKIP_MESSAGE_DURATION);
        },
        handleEndedEvent() {
            this.progressPlaylist();
        },
        back() {
            if(this.activeIndex === 0) {
                this.$emit('instructions')
                return;
            }
            this.activeIndex--;
        },
        progressPlaylist() {
            if(this.isLastPlaylistItem) {
                return;
            }
            this.activeIndex++;
        },
        doAction(action) {
            let selectedAction = this.actionLookup[action];
            if (isFunction(selectedAction)) {
                return selectedAction();
            }

            console.warn(`No action found for: ${action}`)
        },
        handlePrimaryPlayClick(clickAudioButton) {
            if(this.showSkippingMessage) {
                this.showSkippingMessage = false;
                return;
            }

            if(this.activePlaylistItem.action) {
                this.doAction(this.activePlaylistItem.action);
            }

            if(this.activePlaylistItem.audio) {
                clickAudioButton();
                return;
            } else {
                this.handleNoAudioClick()
            }
        },
        actionFullscreen() {
            this.$emit('fullscreen');
        },
        actionVideo() {
            this.$emit('video');
        }
    }
};
</script>